module.exports = __webpack_public_path__ + "img/color-x-2.795dfc4.webp";